<!--
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
-->
<div class="guide">
  <div class="description">
    <div class="heading">Gallery - Wind River's Download and Installation Portal</div>
    <div class="paragraph">
      Welcome to our download site for Wind River's latest product releases. We provide two installation options to meet
      the requirements of different development environments as detailed below. Get started by selecting My Products in
      the left navigation.
      <!-- This URL is no longer supported -->
      <!-- If you do not see your product listed, check our -->
      <!-- <a [href]="esdCenterUrl" target="_blank">ESD Center</a> -->
      <!-- where earlier products or versions are available for download. -->
    </div>
    <div class="paragraph">
      The <a [href]="documentationUrl" target="_blank">Wind River Support Network</a>
      has additional information including User Guides, full product documentation, and installation documentation. If
      you have any questions along the way, please contact
      <a [href]="supportUrl" target="_blank">Support</a>.
    </div>
    <div class="paragraph note">
      Wind River offers two primary installation options: Online and Offline. Choices may vary by product.
    </div>
  </div>
  <div class="description">
    <div class="heading">Installation Guide</div>
  </div>
  <div layout="row" class="option">
    <div class="video">
      <div class="name">Option 1</div>
      <div class="note">Online Installation</div>
      <div class="play">
        <a [href]="onlineVideoUrl" target="_blank" id="video1">
          <img src="assets/video.png" />
          <div>Watch Video</div>
        </a>
      </div>
    </div>
    <div class="steps">
      <div class="note">When to Use</div>
      <ul>
        <li>
          If your network blocks large file downloads, this option uses a smaller initial download (~90MB) with more
          files downloaded during installation.
        </li>
        <li>Installs the product selected (only one).</li>
        <li>Only for installation on host computer with internet access.</li>
        <li>
          Requires network to be able to run an application using Webdav protocol to download additional files during
          installation to complete the process in addition to smaller initial download over HTTPS.
        </li>
      </ul>

      <div class="note">Steps</div>
      <ol>
        <li>Select product from left panel and download the initial installation files.</li>
        <li>
          Run the installer (this process may run for several hours requiring constant internet access). During
          installation, multi-GB of files will be downloaded.
        </li>
      </ol>
    </div>
  </div>

  <div layout="row" class="option">
    <div class="video">
      <div class="name">Option 2</div>
      <div class="note">Offline Installation</div>
      <div class="play">
        <a [href]="offlineVideoUrl" target="_blank" id="video2">
          <img src="assets/video.png" />
          <div>Watch Video</div>
        </a>
      </div>
    </div>
    <div class="steps">
      <div class="note">When to Use</div>
      <ul>
        <li>
          Download everything at one time for a specific product as ZIP file or in UDF format (helpful if making DVDs).
        </li>
        <li>
          Files can be transferred to be installed on a different host computer including those without internet access.
        </li>
        <li>Downloaded installation files can be used for backup or archive.</li>
        <li>
          Must be able to download very large multi-GB single files (ex. Wind River Linux and VxWorks). Network
          throttling may cause issues.
        </li>
        <li>Use standard HTTPS to download large zip files.</li>
        <li>ZIP files are approximately 2 GB each and UDF files are 4 GB each.</li>
      </ul>
      <div class="note">Steps</div>
      <ol>
        <li>Select product from left panel and your custom installation file will be created by Wind River.</li>
        <li>
          Once completed, we will send you a confirmation email with a link to download the full installation file (in
          some cases, this may take a few hours as we create your custom installation file).
        </li>
        <li>
          From the email link, download the installation files (these may be one or more multi-GB files requiring
          high-speed internet connections without network throttling).
        </li>
        <li>Run the installer. This usually ranges from a few minutes to 30 minutes depending on product.</li>
      </ol>
    </div>
  </div>
</div>
